var magicStyles = [".static-page[data-v-5dd25359]{margin:0 auto}.header[data-v-5dd25359]{display:block}.content[data-v-5dd25359]{display:block;margin:var(--magic-space--large,32px) auto}"];

export default magicStyles;
